export default __webpack_public_path__ + "static/media/baby42.3139c02a.gif";